import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-modal-confirm',
    templateUrl: './modal-confirm.component.html'
})
export class ModalConfirmComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
